import { CloseInicis } from '@hellojh/react-inicis';
import React from 'react';

const InicisClose = () => <CloseInicis /> ;
export default InicisClose;